import { render, staticRenderFns } from "./IconPicker.vue?vue&type=template&id=f64530aa&"
import script from "./IconPicker.vue?vue&type=script&lang=js&"
export * from "./IconPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/agent_ai/agent-ai-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f64530aa')) {
      api.createRecord('f64530aa', component.options)
    } else {
      api.reload('f64530aa', component.options)
    }
    module.hot.accept("./IconPicker.vue?vue&type=template&id=f64530aa&", function () {
      api.rerender('f64530aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/IconPicker.vue"
export default component.exports